import React, { FC, PropsWithChildren } from 'react'

export const DocsListTitle: FC<PropsWithChildren> = ({ children }) => {
  return <div className="mb-2 mt-6 text-xl font-bold tracking-tight">{children}</div>
}
